import React, {Component} from 'react'
import Message from "../Message";
import Loader from 'react-loader-spinner'
import validateEmail from "../validateEmail";

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            message: '',
            submitMessage: null,
            loading: false
        }

        this.changeInput = this.changeInput.bind(this);
        this.submitContact = this.submitContact.bind(this);
    }

    changeInput(e){
        this.setState({ [e.target.name]: e.target.value })
    }

    submitContact(e){
        if (this.state.email.trim() === ""){
            this.setState({
                submitMessage: <Message message="Please enter an email" type="error" />
            })
        }
        else if (!validateEmail(this.state.email.trim())){
            this.setState({
                submitMessage: <Message message="Please enter a valid email" type="error" />
            })
        }
        else{
            this.setState({loading: true}, () =>

                fetch("https://api.apispreadsheets.com/data/483/", {
                    method: "post",
                    body: JSON.stringify({data: [{name: "", phone: "", email: this.state.email, message: this.state.message}]})
                }).then((res) => {
                    if (res.status === 201){
                        this.setState({ submitMessage: <Message message="Thank you for contacting us!" body="We will be reaching out shortly" type="success" />, loading: false})
                    }
                    else{
                        this.setState({ submitMessage: <Message message="Your message did not go through :(" body="Please email us at info@unique-tutorials.com" type="error" />, loading: false})
                    }
                }).catch(err => this.setState({ submitMessage: <Message message="Your message did not go through :(" body="Please email us at info@unique-tutorials.com" type="error" />, loading: false}))
            )
        }
    }

    render() {

        return (
            <div>
                <label htmlFor="email">Your Email</label>
                <input type="text" placeholder="awesome.student@gmail.com" id="email" name="email" onChange={this.changeInput} />
                <br/><br/>
                <label htmlFor="message">What do you need help with?</label>
                <textarea name="message" rows="5" placeholder="I need help with Calculus I..." onChange={this.changeInput} />
                <br/>
                <div id="contactSubmitButton">
                    <button type="submit" onClick={this.submitContact}>
                        {this.state.loading ? <Loader
                            type="Puff"
                            color="black"
                            height={20}
                            width={20}
                            timeout={3000} //3 secs

                        /> : <span>Contact Us <i className="fa fa-paper-plane-o" aria-hidden="true" /></span>}
                    </button>
                </div>
                {this.state.submitMessage}
            </div>
        )
    }
}

export default ContactForm